"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayDropoffAnalytics = void 0;
const Analytics_1 = require("../models/Analytics");
const DropoffAnalyticsElement_1 = require("../webComponents/DropoffAnalyticsElement");
const TextBubbleCSS_1 = require("./TextBubble/TextBubbleCSS");
class GameplayDropoffAnalytics {
    constructor(gameplayScene, stylesAlias) {
        this._analyticsViewType = Analytics_1.AnalyticsViewType.HIDE;
        this.gameplayScene = gameplayScene;
        this._stylesAlias = stylesAlias;
    }
    init(analytcisStepData, analyticsViewType) {
        var _a;
        this._analytcisStepData = analytcisStepData;
        this._globalStyles = TextBubbleCSS_1.TextBubbleCSS.getDropoffAnalyticsCSSByAlias(this._stylesAlias);
        const html = `
            <div class="dropoff">
                <div class="dropofftext"></div>
                <div class="dropoffsubtext">
                    <span class="dropoffvalue"></span>
                    <span class="dropoffpercent">%</span>
                </div>
            </div>
        `;
        this._dropoffElement = new DropoffAnalyticsElement_1.DropoffAnalyticsElement({
            template: html,
            styles: this._globalStyles,
        });
        (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.appendChild(this._dropoffElement);
        this.changeViewType(analyticsViewType);
    }
    uninit() {
        var _a;
        if (!this._dropoffElement) {
            return;
        }
        try {
            (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.removeChild(this._dropoffElement);
        }
        catch (e) {
        }
        this._dropoffElement.cleanShadowRoot();
    }
    changeViewType(analyticsViewType) {
        this._analyticsViewType = analyticsViewType;
        if (!this._dropoffElement) {
            return;
        }
        if (this._dropoffElement.dropoffTextDiv) {
            const dropoffText = this.getDropoffText();
            this._dropoffElement.dropoffTextDiv.innerHTML = dropoffText;
        }
        if (this._dropoffElement.dropoffValueDiv) {
            const dropoffValue = this.getDropoffValue();
            this._dropoffElement.dropoffValueDiv.textContent = dropoffValue !== null && dropoffValue !== void 0 ? dropoffValue : "";
        }
        const isCounts = (analyticsViewType === Analytics_1.AnalyticsViewType.COUNTS);
        this._dropoffElement.classList.toggle('is-counts', isCounts);
        const isPercentage = (analyticsViewType === Analytics_1.AnalyticsViewType.PERCENTAGE);
        this._dropoffElement.classList.toggle('is-percentage', isPercentage);
        const isHide = (analyticsViewType === Analytics_1.AnalyticsViewType.HIDE);
        this._dropoffElement.classList.toggle('is-hide', isHide);
    }
    getDropoffText() {
        return this._analyticsViewType === Analytics_1.AnalyticsViewType.COUNTS ? 'User<br>Drop off' : 'Drop off<br>Rate';
    }
    getDropoffValue() {
        if (!this._analytcisStepData) {
            return;
        }
        if (this._analyticsViewType === Analytics_1.AnalyticsViewType.COUNTS) {
            return this._analytcisStepData.dropoff_users.toString();
        }
        if (this._analyticsViewType === Analytics_1.AnalyticsViewType.PERCENTAGE) {
            return this._analytcisStepData.dropoff.toString();
        }
        return '0';
    }
}
exports.GameplayDropoffAnalytics = GameplayDropoffAnalytics;
